import { UserClassName } from '@iotv/datamodel-core';
import { UserDAO } from '../../../../data/SystemManagementDAO';
const debug = process.env.REACT_APP_DEBUG && false;
export const handleDeleteSelectedObjects = async ({ matchedPrimary, selectedObjects, userFunctions, transactionFunctions, location, }) => {
    /** ( search tag mutatedTransactionFunctions) this is currently outside of mutatedTransactionFunctions  */
    debug && console.log(`handleDeleteSelectedObjects via appState`, { matchedPrimary, tableObjects: selectedObjects });
    if (selectedObjects.length > 0) {
        for (const item of selectedObjects) {
            let dependencyError = null;
            if (item.type === UserClassName && typeof item.username === 'string') {
                const { err, data } = await UserDAO.deleteUser(item);
                if (err)
                    dependencyError = err;
                else
                    userFunctions.removeObjectsFromState([item]);
            }
            else {
                debug && console.log(`handleDeleteSelectedObjects wants to delete ${item.sk}`);
            }
            if (!dependencyError) {
                debug && console.log(`handleDeleteSelectedObjects calling transactionFunctions.deleteObject for ${item.sk}`, transactionFunctions.deleteObject);
                await transactionFunctions.deleteObject(item, location);
            }
        }
    }
};
